import React from 'react'

import { FormattedDate } from 'react-intl'

import { IUserInfoResponse } from 'protos'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import VitalStatisticsRow from './VitalStatisticsRow'

interface VitalStatisticsTeamProps {
  topTeamScore?: IUserInfoResponse['topTeamScore']
}

const VitalStatisticsTeam: React.SFC<VitalStatisticsTeamProps> = ({ topTeamScore }) => (
  <VitalStatisticsRow point={topTeamScore!.score!}>
    <Grid container direction="column">
      <Grid item>
        <Typography variant="body1" noWrap>
          {topTeamScore!.match!.homeTeam!.name}
          <span> vs </span>
          {topTeamScore!.match!.awayTeam!.name}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="caption" color="textSecondary">
          <FormattedDate value={1000 * (topTeamScore!.match!.kickoff as number)} />
        </Typography>
      </Grid>
    </Grid>
  </VitalStatisticsRow>
)

export default VitalStatisticsTeam
